export const stopUnthreadChat = () => {
    if (typeof window !== 'undefined' && window.$unthread) {
        window.$unthread.inAppChat('stop');
    }
};

export const startUnthreadChat = (name, email) => {
    if (typeof window !== 'undefined' && window.$unthread) {
        window.$unthread.inAppChat('start', {
            user: {
                name: name || 'Unknown',
                email: email || 'unknown@sepirak.com',
            },
        });
    }
};
